import { render } from "./PaymentTermsPageList.vue?vue&type=template&id=c3d8ee46&scoped=true&ts=true"
import script from "./PaymentTermsPageList.vue?vue&type=script&lang=ts"
export * from "./PaymentTermsPageList.vue?vue&type=script&lang=ts"

import "./PaymentTermsPageList.vue?vue&type=style&index=0&id=c3d8ee46&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d8ee46"]])

export default __exports__